import type { Segment, QueueStage, ExitStage } from '../types';
import { FREE_SPEED, D_JAM, D_CRIT, QLINES } from '../config/crowdConfig';

export { D_JAM, D_CRIT };

export const fmt = (n: number) => Math.round(n).toLocaleString("en-IN");

export const hhmm = (m: number) =>
  String(Math.floor(m / 60) % 24).padStart(2, "0") + ":" + String(Math.round(m) % 60).padStart(2, "0");

export const rnd = (a: number, b: number) => a + Math.random() * (b - a);

export const speedOf = (s: Segment) => (FREE_SPEED[s.kind] || 55) * (s.gradeFactor || 1);

export const capacityOf = (s: Segment) => speedOf(s) * s.width * D_JAM / 4;

export const throughput = (s: Segment, congestedSegmentId: string | null): number => {
  s.cap = capacityOf(s);
  const choke = (congestedSegmentId === s.id) ? 0.42 : 1;
  s.capNow = s.cap * choke;
  const demand = s.vol || 0;
  s.backlog = Math.max(0, (s.backlog || 0) + demand - s.capNow);
  return Math.min(demand, s.capNow);
};

export const segmentDensity = (s: Segment): number => {
  const cap = s.capNow || capacityOf(s);
  const r = Math.min(1, (s.served || 0) / Math.max(1, cap));
  let d = (D_JAM / 2) * (1 - Math.sqrt(Math.max(0, 1 - r)));
  const area = Math.max(60, (s.metres || 220) * s.width);
  d += (s.backlog || 0) / area;
  return Math.min(6.5, d);
};

export const losColor = (d: number): string =>
  d < 0.5 ? "#25D0A3" : d < 1.0 ? "#8ACB86" : d < 2.0 ? "#E9C46A" : d < 3.0 ? "#F0A431" : d < 4.0 ? "#FF6E42" : "#FF4F42";

export const losLabel = (d: number): string =>
  d < 0.5 ? "Free" : d < 1.0 ? "Comfortable" : d < 2.0 ? "Constrained" : d < 3.0 ? "Restricted" : d < 4.0 ? "Critical" : "Crush risk";

export const crowdWord = (d: number): string =>
  d < 1 ? "flowing freely" : d < 2 ? "busy but moving" : d < 3 ? "getting tight"
    : d < 4 ? "very tight" : "dangerously packed";

export const qKey = (l: string, s: string) => `${l}|${s}`;

export const cellArea = (lId: string, st: QueueStage) => {
  const line = QLINES.find(x => x.id === lId);
  const width = line ? line.width : 1.5;
  return Math.max(20, st.len * width);
};

export const cellDens = (l: string, st: QueueStage, cells: Record<string, number>) =>
  (cells[qKey(l, st.id)] || 0) / cellArea(l, st);

export const xArea = (st: ExitStage) => Math.max(40, st.len * st.width);

export const xDens = (st: ExitStage, xcells: Record<string, number>) =>
  (xcells[st.id] || 0) / xArea(st);
